export default __webpack_public_path__ + "static/media/recruit_section_image_2.0b710c59.webp";